<template>
  <!-- Content Left Rail -->
  <div class="settings-center-rail">
    <!-- <call-log v-if="settingsNavSelected == 'calls'"></call-log> -->
    <call-log v-if="settingsNavSelected == 'call-log'"></call-log>
    <unique-customers
      v-if="settingsNavSelected == 'call-uniq-cust'"
    ></unique-customers>
    <telecom-settings
      v-if="
        [
          'telecom-fwd',
          'telecom-trck',
          'telecom-flow',
          'telecom-block'
        ].includes(settingsNavSelected)
      "
      ref="telecom-pane"
    ></telecom-settings>
  </div>
</template>

<script>
const CallLog = () =>
  import(
    /* webpackChunkName: "components-reports-call-CallLog" */ `./reports/CallLog.vue`
  );
const UniqueCustomers = () =>
  import(
    /* webpackChunkName: "components-reports-call-UniqueCustomers" */ `./reports/UniqueCustomers.vue`
  );
const TelecomSettings = () =>
  import(
    /* webpackChunkName: "components-settings-TelecomSettings" */ `../settings/TelecomSettings.vue`
  );

export default {
  name: "CallCenterRail",
  components: {
    CallLog,
    UniqueCustomers,
    TelecomSettings
  },
  props: {
    msg: String
  },
  data: function() {
    return {
      toggleFilter: 1
    };
  },
  created() {},
  watch: {},
  computed: {
    settingsNavSelected() {
      return this.$parent.$parent.$parent.settingsNavSelected;
    }
  },
  methods: {
    navigateTo(settingType) {
      settingType;
    }
  }
};
</script>

<style scoped lang="stylus">
div.settings-left-nav, div.settings-left-nav div {
  background-color: rgb(241, 241, 241);
  width: 100%;
}
.settings-left-nav div.v-list {
  padding: 0;
}
.v-list-item__title {
  padding: 1.5rem 2rem 0.5rem;
  font-size: 1rem;
  font-weight: 500;
  text-transform: uppercase;
}
.subtitle-1 {
  font-size: 1rem;
  font-weight: 400;
}
.v-list-item {
  padding: .5rem 2rem;
}
.settings-center-rail {
  width: 100%;
  padding: 0;
}
</style>
